import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["field", "newClient", "selectClientForm"];
  static values = { id: Number, changed: Boolean, submittedValue: Boolean };
  orderData = {};

  initialize() {
    if (this.idValue) {
      if (!this.getSessionOrder() || this.getSessionOrder() !== this.idValue) {
        window.sessionStorage.setItem("order.current_order", this.idValue);
        window.sessionStorage.removeItem("order.order_data");
      } else if (
        this.getSessionOrder() === this.idValue &&
        this.getSessionOrderData()
      ) {
        this.orderData = JSON.parse(this.getSessionOrderData());
        this.restoreOrder();
      }
    }
  }

  setChanged() {
    this.changedValue = true;
  }

  setSubmitted() {
    this.submittedValue = true;
  }

  addClient(e) {
    console.log("Add client");
    e.preventDefault();
    this.newClientTarget.classList.remove("d-none");
  }

  submitSelectClient(e) {
    this.selectClientFormTarget.dispatchEvent(
      new CustomEvent("submit", { bubbles: true })
    );
  }

  saveOrder() {
    this.fieldTargets.forEach((target) => {
      if (target.id && target.value) {
        if (target.type == "checkbox" || target.type == "radio") {
          this.orderData[target.id] = target.checked;
        } else {
          this.orderData[target.id] = target.value;
        }
      }
    });

    window.sessionStorage.setItem(
      "order.order_data",
      JSON.stringify(this.orderData)
    );
  }

  restoreOrder() {
    this.fieldTargets.forEach((target) => {
      if (Reflect.has(this.orderData, target.id)) {
        if (target.type == "checkbox" || target.type == "radio") {
          target.checked = Reflect.get(this.orderData, target.id);
        } else {
          target.value = Reflect.get(this.orderData, target.id);
        }
      }
    });
  }

  getSessionOrder() {
    return parseInt(window.sessionStorage.getItem("order.current_order"));
  }

  getSessionOrderData() {
    return window.sessionStorage.getItem("order.order_data");
  }

  before(e) {
    if (!this.submittedValue) {
      this.saveOrder();
    }
  }
}
